<template>
    <div class="flex flex-col w-full h-full text-sm bg-gray-50">
        <div class="w-full sticky shadow-md border-b border-gray-300 bg-white">
            <div class="w-full h-20  flex flex-col pl-2 pr-4 text-gray-800 tracking-wide bg-white">
                <div class="w-full flex items-center justify-between">
                    <div class="w-full flex items-center justify-start">
                        <div v-if="viewType=='companies'" class="pl-2 pr-4">
                            <SelectAll
                                :selectAll="selectAll"
                                @toggle-select-all="toggleSelectAll"
                            />
                        </div>
                        <div v-else class="pl-2 pr-4">
                            <div
                            class="h-full cursor-pointer flex flex-row items-center align-middle text-center whitespace-nowrap accent-dark-primary"
                            >
                            <input
                                type="checkbox"
                                id="checkbox"
                                class="align-middle"
                                :checked="selectAll"
                                disabled
                            />
                            </div>
                        </div>
                        <div class="h-12">
                            <CustomTabBar
                                :tab-list="tabs"
                                @set-tab="setPage"
                            />
                        </div>
                    </div>
                    <div
                        v-if="viewType=='companies'"
                        class="rounded-sm hover:bg-gray-200 p-2 hover:cursor-pointer"
                        @click="toggleBulkOperations"
                        ref="bulkOperationsBoundary"
                    >
                        <BulkOperationSVG 
                            :fill="bulkOperationsFill"
                        />
                    </div>
                </div>
                <div class="flex items-center justify-between w-full">
                    <div v-if="viewType=='companies'" class="whitespace-nowrap flex justify-start 2xl:justify-end pl-9 2xl:px-2 2xl:pl-9">
                    {{ selectedResultIds.length }} Selected | {{ numCompanyResults }} {{ companyLabel }}
                    </div>
                    <div v-else  class="whitespace-nowrap flex justify-start 2xl:justify-end pl-9 2xl:px-2 2xl:pl-9">
                        {{ numCompanyResults }} {{ companyLabel }} | {{ numDisplayedClusters }} of {{ numClusterResults }} {{ clusterLabel }}
                    </div>
                    <div class="whitespace-nowrap truncate">
                        {{ totalRevenue }}
                    </div>
                </div>
            </div>
            <div class="flex flex-col justify-center pl-11 pr-4 w-full" v-if="visibleBulkOperations">
                <div class="flex py-2 border-t w-full border-gray-200">
                    <type-ahead-box
                        placeholder="Choose Bulk Operation"
                        nullLabel="No Results"
                        :default-value="null"
                        :options="Object.values(bulkOperations).map((bulkOperation) => { return {value: bulkOperation, label: bulkOperation.label}})"
                        @update-value="updateBulkAction"
                    ></type-ahead-box>
                    <!-- <BaseButton
                        v-for="(bulkOperation, key, index) in bulkOperations"
                        :key="key"
                        :index="index"
                        @click="showBulkActionMenu(bulkOperation)"
                    >
                        {{ bulkOperation.label }}
                    </BaseButton> -->
                </div>
                <div v-if="visibleBulkActionMenu">
                    <div v-if="finishedAction" class="w-full h-full">
                        <div v-if="responseStatus == 200" class="w-full h-full justify-between">
                            <div v-if="bulkOperationQueryParams" class="flex flex-col justify-start items-center p-3 h-[95%]">
                                This action has been performed on all results.
                            </div>
                            <div v-else>
                                This action has been performed on {{ numSelectedResults }} results. 
                            </div>
                            <div class="h-10 flex items-center justify-end">
                                <BaseButtonCancel
                                    @click="cancelBulkOperationClearSelected"
                                >
                                    Close
                                </BaseButtonCancel>
                            </div>
                        </div>
                        <div v-else>
                            <p>{{ bulkAction.label }}: Failed - Bad Request.</p>
                            <br>
                            <p>An error occurred that prevented the completion of this action.</p>
                        </div>
                    </div>
                    <div v-else class="w-full h-full">
                        <div v-if="isLoading">
                            <svg aria-hidden="true" class="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600"
                                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="white"/>
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="#2E9CCA"/>
                            </svg>
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div v-else class="w-full h-full">
                            <div class="w-full h-full">
                                <form action="" @submit.prevent="" class="flex flex-col h-full w-full justify-between">
                                    <div class="h-full">
                                        <div v-for="(inputValue, inputKey, index) in bulkAction.inputs" :key="inputKey" class="p-2 flex flex-col space-y-1">
                                            <div class="tracking-wider font-medium px-1">{{ inputValue.label }}</div>
                                            <div v-if="inputKey=='collectionTag'" class="flex flex-col space-y-4">
                                                <div class="">
                                                    <input
                                                        type="text"
                                                        :id="`input-${index}`"
                                                        :list="`datalist-${index}`"
                                                        class="bg-white p-1 border rounded-sm w-full border-gray-300 text-gray-800 block "
                                                        @change="setCollectionTagPayload"
                                                    />
                                                    <datalist :id="`datalist-${index}`">
                                                        <option value="null">------------</option>
                                                        <option v-for="option in inputValue.options" :key="option.value" :value="`${option.value}`">{{ option.label }}</option>
                                                    </datalist>
                                                </div>
                                                <div class="flex flex-col space-y-1">
                                                    <div class="tracking-wider font-medium px-1 pt-2 border-t border-gray-300">Selected Tags:</div>
                                                    <!-- <div class="ml-1" v-if="!payload || payload.length == 0">
                                                        None
                                                    </div> -->
                                                    <div class="flex flex-wrap">
                                                        <base-pill class="hover:cursor-pointer m-1" @click="removeTag(value)" v-for="value in payload" :key="value">{{ value }} | X</base-pill>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="space-x-3 h-10 flex items-center justify-end">
                                        <BaseButton type="button" @click="submitForm">Submit</BaseButton>
                                        <BaseButtonCancel type="button" @click="cancelBulkOperation">Cancel</BaseButtonCancel>
                                    </div>
                                </form>
                                <br>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <TransitionGroup name="list" tag="div">
            <div v-if="viewType=='companies'" class="w-full h-[calc(100vh-13.5rem)]  2xl:h-[calc(100vh-11.5rem)] overflow-y-scroll scroll-smooth bg-gray-50">
                <CompanyLocationRow
                    v-for="companyLocation in companyLocations"
                    :key="companyLocation.id"
                    :select-all="selectAll"
                    :company-location="companyLocation"
                    :selected-company-location="selectedCompanyLocation"
                    :selected-result-ids="selectedResultIds"
                    @open-company-modal="openCompanyModal"
                    @select-row="addSelectedResult"
                    @deselect-row="removeSelectedResult"
                    @select-company-location="selectCompanyLocation"
                />
            </div>
            <div v-else-if="viewType=='clusters'" class="w-full h-[calc(100vh-13.5rem)] 2xl:h-[calc(100vh-11.5rem)] overflow-y-scroll scroll-smooth  bg-gray-50">
                <ClusterRow
                    v-for="(cluster, index) in clusters.slice(0, numDisplayedClusters)"
                    :key="index"
                    :cluster="cluster"
                    @select-company-cluster="selectCompanyCluster"
                />
                <div v-if="hiddenClusters" class="flex w-full items-center cursor-pointer h-10 border-b border-gray-300 text-gray-800 hover:text-accent-secondary hover:underline" @click="displayMoreClusters(10)">
                    <div class="flex items-start h-full w-12 bg-gray-100">

                    </div>
                    <div class="bg-white  w-full h-full p-2 font-normal">
                        View 10 More Clusters
                    </div>
              
                </div>
            </div>
        </TransitionGroup>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, reactive, computed, watch } from 'vue';
import { performBulkAction } from '@/services/Company';
import CompanyLocationRow from './CompanyLocationRow.vue';
import ClusterRow from './ClusterRow.vue';
import CustomTabBar from '../base-components/CustomTabBar.vue';
import BulkOperationSVG from '../svg-components/BulkOperationSVG.vue';
import SelectAll from '../base-components/SelectAll.vue';
import BaseButton from '../base-components/BaseButton.vue';
import BaseButtonCancel from '../base-components/BaseButtonCancel.vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';

const store = useStore()
const $toast = useToast()

const props = defineProps(['companyLocations', 'clusters', 'numClusters', 'selectedCompanyLocation', 'bulkOperations'])

const emit = defineEmits(['open-company-modal', 'select-company-location', 'select-company-cluster'])

const  viewType = ref('companies')

const numDisplayedClusters = ref(props.companyLocations ? props.companyLocations.length > 2000 ? 10 : props.clusters ? props.clusters.length : 0 : 0 )

watch(() => props.companyLocations.length, () => {
    let resultsLength = props.companyLocations.length
    if(resultsLength > 2000) {
        setPage('clusters')
        if(numClusterResults.value < 10) {
            numDisplayedClusters.value = numClusterResults.value
        } else {
            numDisplayedClusters.value = 10
        }
    } else {
        numDisplayedClusters.value = props.clusters ? props.clusters.length : 0
    }
    if(resultsLength > 7000) {
        disableCompaniesViewType()
        if(numClusterResults.value < 10) {
            numDisplayedClusters.value = numClusterResults.value
        } else {
            numDisplayedClusters.value = 10
        }
    } else {
        enableCompaniesViewType()
    }
})

watch(() => props.numClusters, () => {
    if(props.companyLocations && props.companyLocations.length > 2000) {
        if(numClusterResults.value < 10) {
            numDisplayedClusters.value = numClusterResults.value
        } else {
            numDisplayedClusters.value = 10
        }
    } else {
        numDisplayedClusters.value = props.clusters ? props.clusters.length : 0
    }
})

const hiddenClusters = computed(() => {
    if(props.clusters) {
        if(numDisplayedClusters.value < props.clusters.length) {
            return true
        }
    }
    return false
})


const tabs = reactive({
    companies: {
        label: 'Companies', isSelected: true, enabled: true
    },
    clusters: {
        label: 'Clusters', isSelected: false, enabled: true
    },
})
const bulkOperationsFill = ref('#374151');
const visibleBulkOperations = ref(false)
const visibleBulkActionMenu = ref(false)
const bulkAction = reactive({
    label: null,
    message: null,
    modelPath: null,
    endpoint: null,
    options: null,
    data: null,
})
const isLoading = ref(false);
const finishedAction = ref(false);
const response = ref(null);
const responseStatus = ref(null);
const payload = ref(null);

const selectAll = ref(false)
const selectedResults = ref([]);
const selectedResultIds = computed(() => {
    if(selectedResults.value.length > 0) {
        return selectedResults.value.map(({ id }) => {
            return id;
        });
    } else {
        return [];
    }
})
const numSelectedResults = computed(() => {
    return selectedResultIds.value.length
})

const clearedSelectedResults = ref(false);

const numCompanyResults = computed(() => {
    return props.companyLocations ? props.companyLocations.length : 0
})

const numClusterResults = computed(() => {
    return props.clusters ? props.clusters.length : 0
})

const companyLabel = computed(() => {
    return numCompanyResults.value == 1 ? 'Company' : 'Companies'
})

const clusterLabel = computed(() => {
    return numClusterResults.value == 1 ? 'Cluster' : 'Clusters'
})

const totalRevenue = computed(() => {
    let totalRev = 0;
    props.companyLocations.forEach(companyLocation => {
        const revenueValue = companyLocation?.company?.revenue;
        const parsedRevenue = parseFloat(revenueValue);
        if (!isNaN(parsedRevenue) && isFinite(parsedRevenue)) {
            totalRev += parsedRevenue;
        }
    });
    if (typeof totalRev === 'number') {
        const formattedTotalRev = totalRev.toFixed(2);
        return `$${formattedTotalRev}M`;
    } else {
        return null;
    }
})

function setResultsView(viewTypeValue) {
    viewType.value = viewTypeValue
}

function openCompanyModal(companyId) {
    emit('open-company-modal', companyId)
}

function clearAllTabs() {
    for(const tab of Object.values(tabs)) {
        tab.isSelected = false
    }
}

function setPage(tabKey) {
    if(tabs[tabKey].enabled) {
        clearAllTabs()
        tabs[tabKey].isSelected = true;
        setResultsView(tabKey)
    }
}

function displayMoreClusters(numClusters) {
    if(numDisplayedClusters.value + numClusters >= props.clusters.length) {
        numDisplayedClusters.value = props.clusters.length
    } else {
        numDisplayedClusters.value += 10
    }
}

function disableCompaniesViewType() {
    tabs.companies.enabled = false
}

function enableCompaniesViewType() {
    tabs.companies.enabled = true
}

function toggleBulkOperations() {
    visibleBulkOperations.value = !visibleBulkOperations.value
}

function toggleSelectAll() {
    if(selectAll.value) {
        clearSelectAllClearSelectedResults()
    } else {
        selectAll.value = true;
    }
}

function clearSelectAllClearSelectedResults() {
    clearSelectAll();
    clearSelectedResults();
}

function clearSelectAll() {
  if (selectAll.value) {
    selectAll.value = false;
  }
}

function clearSelectedResults() {
    selectedResults.value = []
    clearedSelectedResults.value = true;
}

function selectCompanyLocation(companyLocation) {
    emit('select-company-location', companyLocation)
}

function selectCompanyCluster(companyCluster) {
    emit('select-company-cluster', companyCluster)
    setPage('companies')
}

function addSelectedResult(resultRow) {
    let foundIndex = selectedResultIds.value.indexOf(resultRow.id)
    if (foundIndex === -1){
        selectedResults.value.push(resultRow);
    }
    // console.log('selected results', selectedResults.value)
}

function removeSelectedResult(resultRow) {
    let foundIndex = selectedResultIds.value.indexOf(resultRow.id);
  if (foundIndex !== -1) {
    selectedResults.value.splice(foundIndex, 1);
  }
}

function showBulkActionMenu(bulkOperation) {
    visibleBulkActionMenu.value = true
    bulkAction.label = bulkOperation.label
    bulkAction.message = bulkOperation.message
    bulkAction.modelPath = bulkOperation.modelPath
    bulkAction.endpoint = bulkOperation.endpoint
}

function updateBulkAction(bulkOperation) {
    if(bulkOperation) {
        visibleBulkActionMenu.value = true
        bulkAction.label=bulkOperation.label
        bulkAction.message=bulkOperation.message
        bulkAction.modelPath=bulkOperation.modelPath
        bulkAction.endpoint=bulkOperation.endpoint
        bulkAction.options=bulkOperation.options
        bulkAction.inputs = bulkOperation.inputs
        bulkAction.data=bulkOperation.data
    } else {
        bulkAction.value = null
        visibleBulkActionMenu.value = false
    }

}


function setCollectionTagPayload(event) {
    if(event.target.value){
        if(Array.isArray(payload.value)){
            if(!payload.value.includes(event.target.value)){
                payload.value.push(event.target.value)
            }
        } else {
            payload.value = [event.target.value]
        }
        event.target.value = null
    }
    // console.log('payload', payload.value)
}

function removeTag(tagName){
    payload.value.splice(payload.value.indexOf(tagName), 1)
}

function cancelBulkOperation() {
    console.log('cancelBulkOperation')
    visibleBulkActionMenu.value = false
    visibleBulkOperations.value = false
    bulkAction.value = null
    payload.value = null
    response.value = null
    finishedAction.value = false
    responseStatus.value = null
}

function cancelBulkOperationClearSelected() {
    cancelBulkOperation()
    clearSelectAllClearSelectedResults()
}

async function submitForm() {
    console.log('performBulkOperation')
    if(payload.value === null) {
        return alert("Please make selection to proceed.")
    }
    isLoading.value = true
    const token = store.state.auth.token
    response.value = await performBulkAction(token, selectedResultIds.value, bulkAction.endpoint, payload.value)
    console.log('bulk action response')
    console.log(response.value)
    console.log(response.value.data)
    isLoading.value = false;
    finishedAction.value = true;
    responseStatus.value = response.value.status
    if(responseStatus.value == 200) {
        $toast.open({
            message:`Completed bulk operation: ${bulkAction.label}`,
            type: 'success',
            duration: 3000
        })
        emit('refetch-results')
    } else {
        $toast.open({
            message: `Could not complete bulk operation: ${bulkAction.label}`,
            type: 'error',
            duration: 10000
        })
    }
}
</script>

<style scoped>
.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 0.25s ease;
}

.list-enter-from,
.list-leave-to {
  transform: translateX(100%);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}
</style>